import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { catchError, map, of, tap } from 'rxjs';
import { PersonService } from '../services/person.service';
import { ToastService } from '../services/toast.service';
import { hasActiveManagerialEmploymentForOrganisation } from '../utils/employment.utils';

export const toolboxMeetingManageGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot,
): ReturnType<CanActivateFn> => {
  const router = inject(Router);
  const personService = inject(PersonService);
  const toastService = inject(ToastService);
  const translateService = inject(TranslateService);

  const meetingId = route.paramMap.get('meetingId');
  const organisationId = route.paramMap.get('organisationId');

  const toolboxesUrl: UrlTree = router.createUrlTree(['/toolboxes']);

  if (!organisationId || !meetingId) {
    return toolboxesUrl;
  }

  return personService.getCurrentPerson().pipe(
    map((person) => {
      const canManageMeeting = hasActiveManagerialEmploymentForOrganisation(person, organisationId);
      if (canManageMeeting) {
        return true;
      }

      return toolboxesUrl;
    }),
    tap((result) => {
      if (result !== true) {
        toastService.showError(translateService.instant('TOOLBOXES.MEETING.ONLY_MANAGERIAL_CAN_MANAGE'));
      }
    }),
    catchError(() => {
      toastService.showError(translateService.instant('TOOLBOXES.MEETING.ONLY_MANAGERIAL_CAN_MANAGE'));
      return of(toolboxesUrl);
    }),
  );
};
